/* RMK 2026 – ruch na stronie (1.11.2026): pojawianie przy przewijaniu, podpowiedź przesuwania smaków,
   pasek haseł i pętle wideo w tle. Bez JS i przy systemowym „ograniczeniu ruchu” treść stoi i jest widoczna. */
(function () {
  var docEl = document.documentElement;
  function mq(q) { return !!(window.matchMedia && window.matchMedia(q).matches); }
  function each(list, fn) { Array.prototype.forEach.call(list, fn); }
  var reduce = mq('(prefers-reduced-motion: reduce)');
  var design = !!(window.Shopify && window.Shopify.designMode);
  var hasIO = 'IntersectionObserver' in window;
  var revealOn = docEl.classList.contains('r26-reveal-on') && !reduce && !design && hasIO;

  /* ---------- 1. pojawianie przy przewijaniu ---------- */
  var TARGETS = [
    ['.r26-section .r26-head', 0],
    ['.r26-flav__list > li', 0],
    ['.r26-disc__media', 1],
    ['.r26-disc__body > *', 0],
    ['.r26-rit__media', 1],
    ['.r26-rit__body > *:not(.r26-facts)', 0],
    ['.r26-rit__body .r26-facts__row', 0],
    ['.r26-bottle', 0],
    ['.r26-ig__grid > li', 0],
    ['.r26-about__inner > *', 0],
    ['.r26-news__inner > *', 0],
    ['.r26-feat__media', 1],
    ['.r26-feat__body > *', 0],
    ['.r26-grid > *', 0],
    ['.r26-accs > *', 0],
    ['.r26-howto__media', 1],
    ['.r26-howto__body > *', 0],
    ['.r26-faq__cols > *', 0]
  ];
  var SKIP = '.r26-hero, .r26-pdp__grid, .r26-sticky, .r26-ticker';
  var io = null;

  function reveal(batch) {
    /* rząd smaków przewijany w bok: pokaż od razu cały rząd */
    batch.slice().forEach(function (el) {
      var p = el.parentElement;
      if (!p || !p.classList.contains('r26-flav__list')) return;
      each(p.children, function (sib) {
        if (sib.classList.contains('r26-rv') && !sib.classList.contains('is-in') && batch.indexOf(sib) === -1) {
          batch.push(sib);
          if (io) io.unobserve(sib);
        }
      });
    });
    batch.sort(function (a, b) { return (a.compareDocumentPosition(b) & 4) ? -1 : 1; });
    batch.forEach(function (el, i) {
      var d = Math.min(i, 7) * 70;
      el.style.setProperty('--r26-d', d + 'ms');
      el.classList.add('is-in');
      setTimeout(function () { el.style.removeProperty('--r26-d'); }, 1900 + d);
    });
  }

  function setupReveal(scope) {
    if (!revealOn) return;
    if (!io) {
      io = new IntersectionObserver(function (entries) {
        var batch = [];
        entries.forEach(function (e) {
          if (e.isIntersecting) { batch.push(e.target); io.unobserve(e.target); }
        });
        if (batch.length) reveal(batch);
      }, { rootMargin: '0px 0px -6% 0px', threshold: 0.06 });
    }
    var vh = window.innerHeight || docEl.clientHeight;
    var fresh = [];
    TARGETS.forEach(function (t) {
      each((scope || document).querySelectorAll(t[0]), function (el) {
        if (el.__r26rv || el.closest(SKIP)) return;
        el.__r26rv = true;
        var r = el.getBoundingClientRect();
        if (r.height > 0 && r.top < vh && r.bottom > 0) return; /* widoczne od razu – bez animacji */
        if (r.height > 0 && r.bottom <= 0) return;              /* już przewinięte */
        el.classList.add('r26-rv');
        if (t[1]) el.classList.add('r26-rv--media');
        fresh.push(el);
      });
    });
    if (!fresh.length) return;
    docEl.classList.add('r26-motion');
    fresh.forEach(function (el) { io.observe(el); });
  }
  window.addEventListener('beforeprint', function () {
    each(document.querySelectorAll('.r26-rv'), function (el) { el.classList.add('is-in'); });
  });

  /* ---------- 2. podpowiedź: rząd smaków da się przesunąć (telefon) ---------- */
  function initHint(list) {
    if (list.__r26h || reduce || design || !hasIO) return;
    list.__r26h = true;
    if (!mq('(max-width: 749px)')) return;
    var obs = new IntersectionObserver(function (entries) {
      if (!entries.some(function (e) { return e.isIntersecting; })) return;
      obs.disconnect();
      setTimeout(function () {
        if (list.scrollLeft > 4 || list.scrollWidth <= list.clientWidth + 8) return;
        list.classList.add('is-hint');
        setTimeout(function () { list.classList.remove('is-hint'); }, 1300);
      }, revealOn ? 1100 : 500);
    }, { threshold: 0.6 });
    obs.observe(list);
    list.addEventListener('touchstart', function () { list.classList.remove('is-hint'); }, { passive: true });
  }

  /* ---------- 3. pasek haseł ---------- */
  function initTicker(el) {
    if (el.__r26t) return;
    el.__r26t = true;
    var track = el.querySelector('.r26-ticker__track');
    var groups = el.querySelectorAll('.r26-ticker__group');
    if (!track || groups.length < 2) return;
    var first = groups[0], second = groups[1];
    var base = Array.prototype.map.call(first.children, function (li) { return li.cloneNode(true); });
    function fill() {
      each(first.querySelectorAll('[data-r26-copy]'), function (n) { n.parentNode.removeChild(n); });
      var guard = 0;
      while (first.scrollWidth < window.innerWidth + 240 && guard < 12) {
        guard++;
        base.forEach(function (li) {
          var c = li.cloneNode(true);
          c.setAttribute('data-r26-copy', '');
          c.setAttribute('aria-hidden', 'true');
          c.removeAttribute('data-shopify-editor-block');
          first.appendChild(c);
        });
      }
      second.innerHTML = first.innerHTML;
      each(second.querySelectorAll('[data-shopify-editor-block]'), function (n) { n.removeAttribute('data-shopify-editor-block'); });
      var speed = parseFloat(el.getAttribute('data-speed')) || 45;
      track.style.setProperty('--r26-ticker-dur', Math.max(8, first.scrollWidth / speed).toFixed(1) + 's');
    }
    fill();
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(fill);
    var lastW = window.innerWidth, t;
    window.addEventListener('resize', function () {
      clearTimeout(t);
      t = setTimeout(function () {
        if (Math.abs(window.innerWidth - lastW) > 40) { lastW = window.innerWidth; fill(); }
      }, 250);
    });
    var btn = el.querySelector('[data-r26-ticker-toggle]');
    el.addEventListener('click', function () {
      var p = !el.classList.contains('is-paused');
      el.classList.toggle('is-paused', p);
      if (btn) {
        btn.setAttribute('aria-pressed', p ? 'true' : 'false');
        btn.setAttribute('aria-label', p ? 'Wznów przewijanie haseł' : 'Zatrzymaj przewijanie haseł');
      }
    });
  }

  /* ---------- 4. pętle wideo w tle ---------- */
  function initVideo(box) {
    if (box.__r26v) return;
    box.__r26v = true;
    if (reduce) return;
    var c = navigator.connection;
    if (c && (c.saveData || /(^|-)2g$/.test(c.effectiveType || ''))) return;
    var wide = box.clientWidth / Math.max(1, box.clientHeight) >= 1.25 && window.innerWidth >= 750;
    function get(k) { return box.getAttribute('data-' + k) || ''; }
    var src = wide ? (get('src-desktop') || get('src-mobile')) : (get('src-mobile') || get('src-desktop'));
    var fb = wide ? (get('fallback-desktop') || get('fallback-mobile')) : (get('fallback-mobile') || get('fallback-desktop'));
    if (!src) return;
    var btn = box.parentElement ? box.parentElement.querySelector('[data-r26-video-toggle]') : null;
    var v = null, userPaused = false, visible = false, triedFb = false;
    function play() {
      if (!v || userPaused || !visible || document.hidden) return;
      var p = v.play();
      if (p && p.catch) p.catch(function () {});
    }
    function make() {
      if (v) return;
      v = document.createElement('video');
      v.className = 'r26-video__el';
      v.muted = true; v.defaultMuted = true; v.loop = true; v.playsInline = true;
      ['muted', 'playsinline', 'webkit-playsinline', 'loop', 'disablepictureinpicture', 'disableremoteplayback'].forEach(function (a) { v.setAttribute(a, ''); });
      v.setAttribute('aria-hidden', 'true');
      v.setAttribute('tabindex', '-1');
      v.preload = 'auto';
      v.addEventListener('playing', function () { box.classList.add('is-playing'); if (btn) btn.hidden = false; });
      v.addEventListener('error', function () {
        if (!triedFb && fb && fb !== src) { triedFb = true; v.src = fb; v.load(); play(); }
      });
      v.src = src;
      box.appendChild(v);
    }
    if (btn) btn.addEventListener('click', function () {
      userPaused = !userPaused;
      btn.setAttribute('aria-pressed', userPaused ? 'true' : 'false');
      btn.setAttribute('aria-label', userPaused ? 'Odtwórz film' : 'Zatrzymaj film');
      if (userPaused) { if (v) v.pause(); } else play();
    });
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) { if (v) v.pause(); } else play();
    });
    function watch() {
      if (!hasIO) { visible = true; make(); play(); return; }
      new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          visible = e.isIntersecting;
          if (visible) { make(); play(); } else if (v) v.pause();
        });
      }, { rootMargin: box.hasAttribute('data-eager') ? '0px' : '300px 0px' }).observe(box);
    }
    if (box.hasAttribute('data-eager')) {
      var go = function () { (window.requestIdleCallback || function (f) { return setTimeout(f, 250); })(watch, { timeout: 1500 }); };
      if (document.readyState === 'complete') go(); else window.addEventListener('load', go, { once: true });
    } else {
      watch();
    }
  }

  function init(scope) {
    var s = scope || document;
    each(s.querySelectorAll('[data-r26-ticker]'), initTicker);
    each(s.querySelectorAll('[data-r26-video]'), initVideo);
    each(s.querySelectorAll('.r26-flav__list'), initHint);
    setupReveal(scope);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
